import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ProcessoCliente } from '../../comum/modelos/processo-cliente';

@Component({
    selector: 'app-modal-setores-rotina',
    templateUrl: './modal-setores-rotina.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-setores-rotina.component.css']
})
export class ModalSetoresRotinaComponent implements OnInit {

    @Input() processoCliente: ProcessoCliente;

    constructor(private modalService: NgbModal) {
    }

    cadastrar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalSetoresRotina',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/modal-setores-rotina/modal-setores-rotina.component.ts